<template>
  <div class='EnbSeoCategorias'>
    <!-- um card por categoria criada pelo usuário; o comp usa o id porque nome e link mudam ao renomear -->
    <enb-seo-card
    v-for="c in CategoriasSeo"
    :key="c.id"
    :comp="'SeoCategoria' + c.id"
    :label="c.name"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbSeoCard from './EnbSeoCard'
export default {
  name: 'EnbSeoCategorias',
  components: { EnbSeoCard },
  computed: {
    ...mapGetters(['Categorias']),
    CategoriasSeo () {
      return this.Categorias.filter(c => c.id)
    }
  },
  methods: {
    ...mapActions(['GetCategory'])
  },
  created () {
    this.GetCategory()
  }
}
</script>
